export function getCookie(name) {
	try {
		if (document.cookie && RegExp) {
			const match = document.cookie.match(new RegExp(`${name}=([^;]+);`));
			const result = match && match[1];
			if (result && decodeURIComponent) {
				return decodeURIComponent(result);
			}
			return result;
		}
		return undefined;
	} catch (e) {
		return undefined;
	}
}

export function setCookie(cname, cvalue, exdays, cpath = "/", cdomain) {
	const cookieData = [`${cname}=${cvalue}`];
	const domain = cdomain || `${window.location.hostname.replace("www.", "")}`;
	if (exdays) {
		const d = new Date();
		d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
		cookieData.push(`expires=${d.toUTCString()}`);
	}
	cookieData.push(`domain=${domain}`);
	cookieData.push(`path=${cpath}`);

	document.cookie = cookieData.join(";").replace(/;$/, "");
}

export function removeCookie(name) {
	document.cookie = `${name}=; Path=/;  Domain=${location.host}; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=None; Secure`;
}
